import React from 'react';
import { AsyncPaginate } from './AsyncPaginate';

export const AsyncSelect = ({ value: initialValue, onChange, onLoadOptions, ...rest }) => {
  const [value, setValue] = React.useState(initialValue?.value ? initialValue : null);

  const handleChange = (option) => {
    setValue(option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <AsyncPaginate
      defaultOptions
      isSearchable
      {...rest}
      value={value}
      useRawValue
      onChange={handleChange}
      loadOptions={onLoadOptions}
      loadOptionsOnMenuOpen={true}
      debounceTimeout={700}
    />
  );
};
